/* Feedogo: play H.265 (HEVC) partner streams inside the live feeder iframe.
   Only streams served from /ll/<12-hex>.flv use the soft decoder (Jessibuca, wasm).
   Every other stream keeps using the original flv.js player untouched. */
(function () {
  'use strict';
  // Self-hosted on the shop CDN (reachable from CN without a proxy); jsdelivr as fallback.
  var JB_BASE = 'https://cdn.shopify.com/s/files/1/0778/2698/2119/t/42/assets/feedogo-';
  var JB_FALLBACK = 'https://cdn.jsdelivr.net/gh/langhuihui/jessibuca@3.3.28/dist/';
  var HEVC_RE = /\/ll\/[0-9a-f]{12}\.flv(\?|$)/;
  var FLV_RE = /\.flv(\?|$)/i;
  function isIOS(win) {
    return /iPhone|iPad|iPod/i.test(win.navigator.userAgent) ||
      (win.navigator.platform === 'MacIntel' && win.navigator.maxTouchPoints > 1);
  }
  function needsSoftDecoder(win, url) {
    return HEVC_RE.test(url) || (isIOS(win) && FLV_RE.test(url));
  }
  var FRAME_ID = 'feedogo-feeder-frame';

  var libs = new WeakMap();
  // Try self-hosted (shop CDN) first; fall back to jsdelivr if it fails (e.g. not yet uploaded).
  function loadJessibucaFrom(win, base) {
    return new Promise(function (resolve, reject) {
      var d = win.document;
      var s = d.createElement('script');
      s.src = base + 'jessibuca.js';
      s.crossOrigin = 'anonymous';
      s.onload = function () {
        win.fetch(base + 'decoder.js').then(function (r) { return r.text(); }).then(function (txt) {
          txt = txt.replace(/(["'])decoder\.wasm\1/g, '$1' + base + 'decoder.wasm$1');
          var url = win.URL.createObjectURL(new win.Blob([txt], { type: 'application/javascript' }));
          resolve(url);
        }).catch(reject);
      };
      s.onerror = function () { reject(new Error('jessibuca load failed from ' + base)); };
      d.head.appendChild(s);
    });
  }
  function ensureJessibuca(win) {
    if (libs.has(win)) return libs.get(win);
    var p = loadJessibucaFrom(win, JB_BASE).catch(function () { return loadJessibucaFrom(win, JB_FALLBACK); });
    libs.set(win, p);
    p.catch(function () { libs.delete(win); });
    return p;
  }

  function HevcPlayer(win, real, url) {
    this.win = win; this.real = real; this.url = url;
    this.handlers = {}; this.video = null; this.box = null; this.j = null; this.dead = false;
    this._vol = null;
  }
  HevcPlayer.prototype.on = function (evt, fn) { (this.handlers[evt] = this.handlers[evt] || []).push(fn); };
  HevcPlayer.prototype.emit = function (evt, a, b, c) {
    (this.handlers[evt] || []).forEach(function (fn) { try { fn(a, b, c); } catch (e) {} });
  };
  HevcPlayer.prototype.attachMediaElement = function (video) {
    var self = this, d = this.win.document;
    this.video = video;
    var box = d.createElement('div');
    box.setAttribute('data-hevc-box', '1');
    box.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;background:#0b201b;overflow:hidden';
    video.parentNode.insertBefore(box, video.nextSibling);
    this.box = box;
    video.play = function () { return Promise.resolve(); };
    this._vol = function () {
      if (!self.j) return;
      try {
        if (video.muted || video.volume === 0) self.j.mute();
        else { self.j.cancelMute(); self.j.setVolume(video.volume); }
      } catch (e) {}
    };
    video.addEventListener('volumechange', this._vol);
  };
  HevcPlayer.prototype.load = function () {
    var self = this, E = this.real.Events;
    ensureJessibuca(this.win).then(function (decoder) {
      if (self.dead) return;
      var j = new self.win.Jessibuca({
        container: self.box, videoBuffer: 0.3, isResize: false, isFullResize: true,
        useMSE: false, decoder: decoder, text: '', loadingText: '', debug: false,
        showBandwidth: false, hasAudio: true, loadingTimeout: 20, heartTimeout: 10,
        operateBtns: { fullscreen: false, screenshot: false, play: false, audio: false }
      });
      self.j = j;
      j.on('videoInfo', function () { self._vol && self._vol(); self.emit(E.MEDIA_INFO, {}); });
      // First decoded frame: lets feedogo-live-waiting.js remove its waiting screen.
      j.on('timeUpdate', function () { if (self.box) self.box.setAttribute('data-hevc-live', '1'); });
      j.on('error', function (e) { self.emit(E.ERROR, 'NetworkError', String(e), {}); });
      j.on('timeout', function (e) { self.emit(E.ERROR, 'NetworkError', String(e), {}); });
      j.play(self.url).catch(function (e) { self.emit(E.ERROR, 'NetworkError', String(e), {}); });
    }).catch(function (e) { self.emit(E.ERROR, 'NetworkError', String(e), {}); });
  };
  HevcPlayer.prototype.play = function () {};
  HevcPlayer.prototype.pause = function () {};
  HevcPlayer.prototype.unload = function () {};
  HevcPlayer.prototype.detachMediaElement = function () {};
  HevcPlayer.prototype.destroy = function () {
    this.dead = true;
    try { this.j && this.j.destroy(); } catch (e) {}
    this.j = null;
    try { this.box && this.box.remove(); } catch (e) {}
    if (this.video) {
      try { this.video.removeEventListener('volumechange', this._vol); } catch (e) {}
      try { delete this.video.play; } catch (e) {}
    }
  };

  function install(win) {
    var real = win.flvjs;
    if (!real || win.__hevcShim) return;
    win.__hevcShim = 1;
    win.flvjs = new Proxy(real, {
      get: function (t, k) {
        if (k === 'createPlayer') {
          return function (ds, cfg) {
            if (ds && needsSoftDecoder(win, String(ds.url || ''))) return new HevcPlayer(win, t, ds.url);
            return t.createPlayer.apply(t, arguments);
          };
        }
        var v = t[k];
        return typeof v === 'function' ? v.bind(t) : v;
      }
    });
    // The page may already have tried (and failed) to play the current partner stream
    // with the original player before this patch was installed: restart it once.
    setTimeout(function () {
      try {
        var u = String(win.__liveKey || '').split('|')[1] || '';
        if (needsSoftDecoder(win, u) && typeof win.startLiveStream === 'function') win.startLiveStream(u);
      } catch (e) {}
    }, 300);
  }

  function tryInstall() {
    var f = document.getElementById(FRAME_ID);
    if (!f) return false;
    try {
      var w = f.contentWindow;
      if (!w || !w.flvjs || !w.document.getElementById('liveVideo')) return false;
      install(w);
      return true;
    } catch (e) { return false; }
  }

  var n = 0;
  var timer = setInterval(function () {
    if (tryInstall() || ++n > 1500) clearInterval(timer);
  }, 20);

})();
